/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

/* Component Imports */

import { Typography, Slider, TextField } from "@material-ui/core";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  label: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.25rem",
    margin: "2rem 0rem 1rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "3rem 0rem 0.5rem 0rem",
    },
  },
  sliderRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  slider: {
    width: "70%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "2rem",
    },
  },
  textField: {
    width: "25%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

const marks = [
  {
    value: 6,
    label: "6%",
  },
  {
    value: 8,
    label: "8%",
  },
  {
    value: 10,
    label: "10%",
  },
  {
    value: 12,
    label: "12%",
  },
  {
    value: 15,
    label: "15%",
  },
];

const EMIInterest = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Typography variant="body2" component="p" className={classes.label}>
          Rate of interest (%)
        </Typography>
        <div className={classes.sliderRow}>
          <Slider
            className={classes.slider}
            onChange={props.onChangeInterestSlider}
            step={0.25}
            min={6}
            max={15}
            value={props.value}
            marks={marks}
          />
          <TextField
            className={classes.textField}
            onChange={props.onChangeInterestTextField}
            value={props.value}
            label="Interest (%)"
          />
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Skeleton>
          <Typography variant="body2" component="p" className={classes.label}>
            Rate of interest (%)
          </Typography>
        </Skeleton>
        <div className={classes.sliderRow}>
          <Skeleton width="100%">
            <Slider
              className={classes.slider}
              onChange={props.onChangeInterestSlider}
              step={0.25}
              min={6}
              max={15}
              value={props.value}
              marks={marks}
            />
            <TextField
              className={classes.textField}
              onChange={props.onChangeInterestTextField}
              value={props.value}
              label="Interest (%)"
            />
          </Skeleton>
        </div>
      </React.Fragment>
    );
  }
};

export default EMIInterest;
